import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/Reveal";
import { Overline as OverlineTag } from "@/components/primitives";
import { IMAGES } from "@/data/content";

export default function EcosystemManifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative py-24 md:py-36 border-b hairline" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-7">
          <Reveal><OverlineTag>01 — The Premise</OverlineTag></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-heading font-light text-navy tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              Influence lives in&nbsp;ecosystems.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 space-y-6 max-w-xl text-lg leading-relaxed text-ink/75 font-body">
              <p>
                Every industry has its own network of platforms, conferences, executive communities,
                associations, recognition programs and decision-makers. The challenge isn't finding
                visibility. It's knowing which visibility matters.
              </p>
              <p className="text-navy font-heading font-light text-2xl leading-snug">
                Influence does not float freely. It lives in specific rooms.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5 lg:pt-4">
          <div className="relative overflow-hidden aspect-[4/5]">
            <motion.img
              style={{ y }}
              src={IMAGES.facade}
              alt="Architectural facade"
              className="absolute inset-0 w-full h-[116%] object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
